module.exports = __webpack_public_path__ + "static/media/photo26.be4cdfba.jpg";